module.exports = __webpack_public_path__ + "static/img/faqs2.b33749d.png";